import { NotificationModel } from '../../module/notification/model/notification.model';
import { SystemService } from '../../core/system/system.service';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private BASE_URL = `${environment.NOTIFICATION}/notification/event`;


    constructor(
        private zone: NgZone,
        private systemService: SystemService,
        private httpService: HttpClient
    ) {}

    public connectToSSEServer(): Observable<NotificationModel | string> {
        const token = this.systemService.getLocalStorage('token') as string;
        const url = `${this.BASE_URL}/stream`;

        return new Observable<NotificationModel | string>(observer => {
            const ctrl = new AbortController();

            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'text/event-stream',
                    'Authorization': token,
                    'X-Device-Info': this.systemService.getDeviceId()!
                },
            }).then(async response => {
                if (!response.ok) {
                    observer.error(`Erro: ${response.status}`);
                    return;
                }

                const reader = response.body?.getReader();
                const decoder = new TextDecoder();

                if (!reader) {
                    observer.error('Corpo da resposta vazio');
                    return;
                }

                try {
                    while (true) {

                        const { value, done } = await reader.read();
                        if (done) {
                            observer.complete();
                            break;
                        }
                        const chunk = decoder.decode(value, { stream: true });
                        const parsedChunk = this.parseSSEMessage(chunk)

                        this.zone.run(() => {
                            try {
                                const parsedData: NotificationModel = JSON.parse(parsedChunk);
                                observer.next(parsedData);
                            } catch {
                                observer.next(parsedChunk);
                            }
                        });
                    }

                    this.zone.run(() => observer.complete());
                } catch (err) {
                    this.zone.run(() => observer.error(err));
                }
            })
            .catch(err => {
                this.zone.run(() => observer.error(err));
            });

            return () => {
                ctrl.abort();
            };
        });
    }
    public getNotifications(query: { limit: number, skip: number }): Observable<NotificationModel[]> {
        return this.httpService.get<NotificationModel[]>(`${this.BASE_URL}`, { params: query });
    }
    public deleteNotification(notificationId: string): Observable<void> {
        return this.httpService.delete<void>(`${this.BASE_URL}/${notificationId}`);
    }
    public markNotificationAsRead(notificationId: string): Observable<void> {
        return this.httpService.patch<void>(`${this.BASE_URL}/${notificationId}/read`, null);
    }
    private parseSSEMessage(chunk: string) {
        /**
         * The SSE message follows the pattern:
         *
         * id: <numeric id of the message>
         * data: <payload sent>
         *
         * eg.:
         *
         *   id: 3
         *   data: {'title':'Data de liberação alterada'}
         */
        const parts = chunk.split('\n').filter(Boolean);

        return parts.at(1)?.replace('data: ', '') || '';
    }
}
